export const SITE_WIDE_VACATION_SEARCH = 'SITE_WIDE_VACATION_SEARCH';
